<template>
  <v-container fluid>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>
      <v-card>
        <v-card-title>
          {{lang.itemCard}}: {{ itemCrd.itemName }}, {{ itemCrd.itemID }}
          <v-btn
            text color="primary"
            @click="printAna()">
            {{langC.Print}}
          </v-btn>

          <v-btn
            text color="primary"
            @click="pushToDocument()">
            {{lang.PushToDocument}}
          </v-btn>

          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>

        <v-data-table
            dense
            :headers="headers"
            :items="items"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            v-model="selected"
            show-select
          >
          <template v-slot:[`item.documentDate`]="{ item }">
              <span>{{ localDate(item.documentDate) }}</span>
          </template>
          <template v-slot:[`item.itemPcsMinus`]="{ item }">
              <span>{{ localMoney(item.itemPcsMinus) }}</span>
          </template>
          <template v-slot:[`item.itemPcsPlus`]="{ item }">
              <span>{{ localMoney(item.itemPcsPlus) }}</span>
          </template>
          <template v-slot:[`item.itemState`]="{ item }">
              <span>{{ localMoney(item.itemState) }}</span>
          </template>
           <template v-slot:[`item.itemPriceWithVAT`]="{ item }">
              <span>{{ localMoney(item.itemPriceWithVAT) }}</span>
          </template>
          <template v-slot:[`item.TotalPlus`]="{ item }">
              <span>{{ localMoney(item.TotalPlus) }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>



          <v-card-text>
            {{lang.itemTotalPlus}} {{localMoney(totalPcsPlus)}},{{lang.itemTotalMinus}} {{localMoney(totalPcsMinus)}}, {{lang.itemTotal}} {{localMoney(totalPcs)}} <br />
            <span v-if="totalSupp"> {{lang.ItemSuppPriceAmount}}: {{localMoney(totalSupp)}},</span>
            <span v-if="totalMargin"> {{lang.ItemMarginAmount}}: {{localMoney(totalMargin)}},</span>
            <span v-if="totalNetto"> {{lang.ItemBaseAmountNoVAT}}: {{localMoney(totalNetto)}},</span>
            <span v-if="totalVAT"> {{lang.ItemVAT1Amount}}: {{localMoney(totalVAT)}},</span> 
            <span v-if="totalTotal"> {{lang.ItemFullTotal}}: {{localMoney(totalTotal)}}</span> 
          </v-card-text>
      </v-card>
      <v-row>
        <v-col cols="12" sm="10" md="10" xs="10" lg="10" xl="10">
          <DocumentPrintItemCard ref="prnt" />
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import DocumentService from '@/services/DocumentService'
import DocumentPrintItemCard from './DocumentPrintItemCard'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import documentLocalName from '@/snippets/documentLocalName'
import documentCurrency from '@/snippets/documentCurrency'
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import dayjs from 'dayjs'
import {defDocumentDetail, defNewDocumentDetail} from './documentHelper'
import { round, parseNum } from '@/snippets/allSnippets'

export default {
  name: 'documentitemcard',
  props: [],
  data () {    
    return {
      selected: [],
      items: [],
      documentName: '',
      documentNameLoc: '',
      msg: '',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      totalPcsPlus: 0,
      totalPcsMinus: 0,
      totalPcs: 0,
      totalSupp: 0,
      totalMargin: 0,
      totalNetto: 0,
      totalVAT: 0,
      totalDirect: 0, 
      totalTotal: 0,
      defCurr: 'EUR',
      itemState: 0,
      itemName: '',
      itemID: '',
      itemCrd:{},
      newDD:{},
      allItems:[]
    }
  },
  beforeMounted(){
    console.log('prije mounteda')
  },
  async mounted () {

    if (this.$store.state.documentAna && Object.keys(this.$store.state.documentAna).length > 0) {
      this.saving = true
      const res = (await DocumentService.documentitemcard(this.$store.state.documentAna)).data
      this.newCardItems = res && res.document && res.document[0] ? res.document[0] : []
    }
    this.itemCrd = this.$store.state.itemActiv ? this.$store.state.itemActiv : null
    // console.log('unutar mounteda')
    // console.log('itemCrd', this.itemCrd)
    // console.log('kartica artikla newCardItems', this.newCardItems)

        // do analysis from database
        if (this.$store.state.language === 'EN') {
          this.lang = langEn
          this.langC = commEn
        }
        if (this.$store.state.language === 'HR') {
          this.lang = langHr
          this.langC = commHr
        }
        this.defCurr = documentCurrency()
        this.headers.push(
          {text: this.lang.documentDate1, value: 'documentDate', width: '110px'},
          {text: this.lang.documentId, value: 'documentId', width: '80px'},
          {text: this.langC.DocumentName, value: 'documentName', width: '80px'},
          {text: this.lang.partnerName, value: 'partnerNameDatabase', width: '150px'},
          {text: this.lang.ItemPcsPlus, value: 'itemPcsPlus', type: 'decimal', width: '100px'},
          {text: this.lang.ItemPcsMinus, value: 'itemPcsMinus', type: 'decimal', width: '100px'},
          {text: this.lang.itemState, value: 'itemState', type: 'decimal', width: '100px'},
          {text: this.lang.ItemSuppBasePrice, value: 'itemSuppBasePrice', type: 'decimal', width: '100px'},
          {text: this.lang.ItemSuppDiscount, value: 'itemSuppDiscount', type: 'decimal', width: '60px'},
          {text: this.lang.ItemSuppPrice, value: 'itemSuppPrice', type: 'decimal', width: '100px'},
          {text: this.lang.ItemMargin, value: 'itemMargin', type: 'decimal', width: '60px'},
          {text: this.lang.ItemPrice, value: 'itemPrice', type: 'decimal', width: '100px'},
          {text: this.lang.ItemPriceWithVAT, value: 'itemPriceWithVAT', type: 'decimal', width: '100px'},
          {text: this.lang.TotalPlus, value: 'TotalPlus', type: 'decimal', width: '100px'},
          {text: this.lang.id, value: 'id', width: '50px'}
        )
        
        // do analysis from database
        this.localError = false
        this.error = null
        this.items = []
 
        this.saving = false
        let iid = 0
        this.totalPcs = 0
        this.totalSupp = 0
        this.totalMargin = 0
        this.totalNetto = 0
        this.totalVAT = 0
        this.totalDirect = 0
        this.totalTotal = 0
        if (this.newCardItems) {
            this.newCardItems.map(item => {
              const newEntry = {}
                newEntry.itemID = item.itemID ? item.itemID : ''
                newEntry.itemName = item.itemName ? item.itemName : ''
                newEntry.documentDate = item.documentDate ? item.documentDate : ''
                newEntry.documentName = item.documentName ? documentLocalName(item.documentName): ''
                newEntry.documentId = item.documentId ? item.documentId : ''
                newEntry.partnerNameDatabase = item.partnerNameDatabase ? item.partnerNameDatabase : ''
                newEntry.itemPcsPlus = item.itemPcsPlus ? item.itemPcsPlus : null
                newEntry.itemPcsMinus = item.itemPcsMinus ? item.itemPcsMinus : null
                newEntry.itemSuppBasePrice = item.itemSuppBasePrice ? item.itemSuppBasePrice : ''
                newEntry.itemSuppDiscount = item.itemSuppDiscount ? item.itemSuppDiscount : ''
                newEntry.itemSuppPrice = item.itemSuppPrice ? item.itemSuppPrice : ''
                newEntry.itemMargin = item.itemMargin ? item.itemMargin : ''
                newEntry.itemPrice = item.itemPrice ? item.itemPrice : ''
                newEntry.itemPriceWithVAT = item.itemPriceWithVAT ? item.itemPriceWithVAT : ''
                if (item.itemPcsPlus) {                
                  this.totalPcsPlus += parseFloat(item.itemPcsPlus)
                  newEntry.TotalPlus = this.totalPcsPlus
                } 
                if (item.itemPcsMinus) {                
                  this.totalPcsMinus += parseFloat(item.itemPcsMinus)
                  newEntry.TotalMinus = this.totalPcsMinus
                }
                newEntry.itemState = this.totalPcsPlus - this.totalPcsMinus    
                if (item.itemSuppPriceAmount) {
                  this.totalSupp += parseFloat(item.itemSuppPriceAmount)
                }
                if (item.itemMarginAmount ) {
                  this.totalMargin += parseFloat(item.itemMarginAmount)
                }
                if (item.itemBaseAmountNoVAT) {
                  this.totalNetto += parseFloat(item.itemBaseAmountNoVAT)
                }
                if (item.itemVAT1Amount) {
                  this.totalVAT += parseFloat(item.itemVAT1Amount)
                }
                if (item.itemFullTotal) {
                  this.totalTotal += parseFloat(item.itemFullTotal)
                }
                iid += 1
                newEntry.id = iid
                this.items.push(newEntry)
              
            })
            this.totalPcs = this.totalPcsPlus - this.totalPcsMinus
           }
        

        this.typeAna = 4
  },
  methods: {     
    navigateTo () {
    },
     getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    pushToDocument() {
      this.allItems.length = 0
      this.allItems = this.$store.state.documentActivItems ? [...this.$store.state.documentActivItems] : []
      const neIdi = false
      if (this.selected.length > 0 ) {
        this.selected.map(item => {
          this.newDD = defDocumentDetail()
          this.newDD = {...this.documentDet, ...defNewDocumentDetail()}
          const newId = this.getRndInteger(1000000000, 9000000000)
          this.newDD.id = newId
          let pcs = 0
          const itemPcsMinus = parseNum(item.itemPcsMinus, 2)
          const itemPcsPlus = parseNum(item.itemPcsPlus, 2)
          if (itemPcsMinus > 0) {
            pcs = itemPcsMinus
          }
           if (itemPcsPlus > 0) {
            pcs = itemPcsPlus
          }
          const fromStore = this.$store.state.itemStore.find(itm => itm.itemID === item.itemID)
          
          this.newDD.itemID = item.itemID
          this.newDD.itemName = fromStore.itemName
          this.newDD.ItemNameShort = fromStore.itemName
          this.newDD.itemGroup = fromStore && fromStore.GroupId ? fromStore.GroupId : ''
          this.newDD.itemGroupName = fromStore && fromStore.GroupName ? fromStore.GroupName : ''
          this.newDD.itemUnit = fromStore && fromStore.itemUnit ? fromStore.itemUnit : ''
          this.newDD.itemService = fromStore && fromStore.itemService ? fromStore.itemService : false
          this.newDD.ItemHomeCurrency = 'EUR'
          this.newDD.itemDiscountPercentage1 = 0
          this.newDD.itemVAT1Percentage = fromStore && fromStore.itemVAT1Percentage ? fromStore.itemVAT1Percentage : ''
          this.newDD.TypeName = fromStore && fromStore.TypeName ? fromStore.TypeName : '' 
          this.newDD.PotpunaSifra = fromStore && fromStore.PotpunaSifra ? fromStore.PotpunaSifra : '' 
          
          this.newDD.itemSuppBasePrice = parseNum(item.itemSuppBasePrice,2)
          this.newDD.itemSuppDiscount = parseNum(item.itemSuppDiscount,2)
          this.newDD.itemSuppPrice = parseNum(item.itemSuppPrice,2)
          this.newDD.itemMargin = parseNum(item.itemMargin,2)
          this.newDD.itemPrice = parseNum(item.itemPrice,2)
          this.newDD.itemPriceWithVAT = parseNum(item.itemPriceWithVAT,2)
          this.newDD.itemForePrice = parseNum(item.itemPrice,2)
          this.newDD.itemForePriceWithVAT = parseNum(item.itemPriceWithVAT,2)
          if (this.$store.state.documentSide === 1) {
            this.newDD.itemPcsPlus = pcs
          }
          if (this.$store.state.documentSide === 2) {
            this.newDD.itemPcsMinus = pcs
          }
          if (this.$store.state.documentSide === 3) {
            this.newDD.itemPcsNeutral = pcs
          }


          this.newDD.itemDirectDuty1 = 0
          this.newDD.itemSuppBasePriceAmount  = (parseNum(item.itemSuppBasePrice,2) * pcs) ? round((parseNum(item.itemSuppBasePrice,2) * pcs),2) : 0
          this.newDD.itemSuppPriceAmount  = this.newDD.iSuppBasePriceAmount
          this.newDD.itemBaseAmount = (parseNum(item.itemPrice,2) * pcs) ? (parseNum(item.itemPrice,2) * pcs): 0
          this.newDD.itemBaseAmount = round(this.newDD.itemBaseAmount, 2)
          this.iMarginAmount = round((this.newDD.itemBaseAmount - this.newDD.itemSuppPriceAmount),2)

          this.newDD.itemDiscountAmount1 =  0
          this.newDD.itemDiscountAmount1 = round(this.newDD.itemDiscountAmount1, 2)
          this.newDD.itemBaseAmountNoVAT = this.newDD.itemBaseAmount  - this.newDD.itemDiscountAmount1
          this.newDD.itemBaseAmountNoVAT = round(this.newDD.itemBaseAmountNoVAT, 2)
          this.newDD.itemDiscountPrice = this.newDD.itemBaseAmountNoVAT && round(pcs,2) !== 0  ? round(this.newDD.itemBaseAmountNoVAT / pcs, 2)  : 0
          
          this.newDD.itemAmountWithVAT = this.newDD.itemBaseAmountNoVAT * (1 + (this.newDD.itemVAT1Percentage / 100)) ? this.newDD.itemBaseAmountNoVAT * (1 + (this.newDD.itemVAT1Percentage / 100)) : 0
          this.newDD.itemAmountWithVAT = round(this.newDD.itemAmountWithVAT, 2)
          this.newDD.itemVAT1Amount = this.newDD.itemAmountWithVAT - this.newDD.itemBaseAmountNoVAT
          this.newDD.itemPriceWithVAT = this.newDD.itemAmountWithVAT && round(pcs, 2) !== 0 ? round(this.newDD.itemAmountWithVAT / pcs, 2)  : 0
          this.newDD.itemDirectDuty1Amount = round((this.newDD.itemDirectDuty1 * pcs), 2)
          this.newDD.itemFullTotal = (this.newDD.itemAmountWithVAT + this.newDD.itemDirectDuty1Amount)
          this.newDD.itemFullTotal = round(this.newDD.itemFullTotal, 2)

          // if is PPO, then there is no VAT
          if (this.$store.state.documentActivHead.PPO === true) {
            this.newDD.itemAmountWithVAT = this.newDD.itemBaseAmountNoVAT
            this.newDD.itemAmountWithVAT = round(this.newDD.itemAmountWithVAT, 2)
            this.newDD.itemVAT1Percentage =  0
            this.newDD.itemVAT1Amount = 0
            this.newDD.itemPriceWithVAT = this.newDD.itemAmountWithVAT && round(pcs, 2) !== 0  ? round(this.newDD.itemAmountWithVAT / pcs, 2)  : 0
            this.newDD.itemDirectDuty1Amount = round((this.newDD.itemDirectDuty1 * pcs), 2)
            this.newDD.itemFullTotal = (this.newDD.itemAmountWithVAT + this.newDD.itemDirectDuty1Amount)
            this.newDD.itemFullTotal = this.newDD.round(this.newDD.itemFullTotal, 2)
            }
          // ako nije u sustavu PDVa
          if (this.$store.state.companyActiv.notinVAT === true) {
            this.newDD.itemAmountWithVAT = this.newDD.itemBaseAmountNoVAT
            this.newDD.itemAmountWithVAT = round(this.newDD.itemAmountWithVAT, 2)
            this.newDD.itemVAT1Percentage =  0
            this.newDD.itemVAT1Amount = 0
            this.newDD.itemPriceWithVAT = this.newDD.itemAmountWithVAT && round(pcs, 2) !== 0  ? round(this.newDD.itemAmountWithVAT / pcs, 2)  : 0
            this.newDD.itemDirectDuty1Amount = round((this.newDD.itemDirectDuty1 * pcs), 2)
            this.newDD.itemFullTotal = (this.newDD.itemAmountWithVAT + this.newDD.itemDirectDuty1Amount)
            this.newDD.itemFullTotal = this.newDD.round(this.newDD.itemFullTotal, 2)
          }
          this.setKategorije()

          this.allItems.push(this.newDD)
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        })
        if (this.allItems) {
            this.$store.dispatch('setDocumentActivItems', this.allItems)
        } else {
          this.$store.dispatch('setDocumentActivItems', [])
        }
        this.makeSum()
      }
    },
    makeSum() {
      const updateSumObject = {
        documentDescription9: 0,
        documentDescription10: 0,
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: this.$store.state.documentActivHead.documentTotalAmountPayInAdvance ? parseFloat(this.$store.state.documentActivHead.documentTotalAmountPayInAdvance) : 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0,
        supplierAmount: 0,
        supplierNetoAmount: 0,
        supplierDiscount: 0,
        supplierMargin: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
      }
      let dSide = 3
      if (this.$store.state.documentSide) {
        dSide = this.$store.state.documentSide
      }

      const hrVat1 = 25
      const hrVat2 = 13
      const hrVat3 = 5
  
      if (this.allItems) {
        this.allItems.map(documentDet => {

          this.pcsLoc = 0
          if (dSide === 1 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsPlus) ? parseFloat(documentDet.itemPcsPlus)  : 0
          }
          if (dSide === 2 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsMinus) ? parseFloat(documentDet.itemPcsMinus)  : 0
          }
          if (dSide === 3 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsNeutral) ? parseFloat(documentDet.itemPcsNeutral)  : 0
          }
          this.pcsLoc = this.round(this.pcsLoc, 3)     
          
          if ((documentDet.itemSuppBasePriceAmount)) {
            updateSumObject.supplierAmount += this.round((documentDet.itemSuppBasePriceAmount),2)
          }
          if (documentDet.itemSuppDiscountAmount) {
            updateSumObject.supplierDiscount += this.round(documentDet.itemSuppDiscountAmount,2)
          }
          if (documentDet.itemSuppPriceAmount) {
            updateSumObject.supplierNetoAmount += this.round(documentDet.itemSuppPriceAmount,2)
          }
          if (documentDet.itemBaseAmount) {
            updateSumObject.documentDescription9 += parseFloat(documentDet.itemBaseAmount)
          }
          if (documentDet.itemBaseAmountNoVAT) {
            updateSumObject.documentTotalAmountNetto += parseFloat(documentDet.itemBaseAmountNoVAT)
          }

          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat1) {
            updateSumObject.documentTotalVAT1Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT1Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT1Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat2) {
            updateSumObject.documentTotalVAT2Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT2Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT2Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat3) {
            updateSumObject.documentTotalVAT3Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT3Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT3Base += (parseFloat(documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (documentDet.itemBaseAmount) {
            if (parseInt(documentDet.FreeF1) === 1) {
              updateSumObject.FreeF1 += parseFloat(documentDet.itemBaseAmount)
            }
            if (parseInt(documentDet.FreeF1) === 2) {
              updateSumObject.FreeF2 += parseFloat(documentDet.itemBaseAmount)
              updateSumObject.FreeF5 += parseFloat(documentDet.empWrkHrs)
            }
            if (parseInt(documentDet.FreeF1) === 3) {
              updateSumObject.FreeF3 += parseFloat(documentDet.itemBaseAmount)
            }
          }
          if (documentDet.itemBaseAmountNoVAT) {
            if (this.round(parseFloat(documentDet.itemVAT1Amount),2) === 0) {
              updateSumObject.FreeF4 += parseFloat(documentDet.itemBaseAmountNoVAT)
            }
          }
          if (documentDet.itemDirectDuty1Amount) {
            updateSumObject.documentTotalAmountDirectD1+= parseFloat(documentDet.itemDirectDuty1Amount)
          }
        })
      }

      updateSumObject.documentTotalAmountNetto = updateSumObject.documentTotalAmountNetto ? this.round(updateSumObject.documentTotalAmountNetto, 2) : 0
      updateSumObject.documentTotalVAT1Amount  = this.round((updateSumObject.documentTotalVAT1Base * ( (hrVat1/100))),2)
      updateSumObject.documentTotalVAT2Amount  = this.round((updateSumObject.documentTotalVAT2Base * ( (hrVat2/100))),2)
      updateSumObject.documentTotalVAT3Amount  = this.round((updateSumObject.documentTotalVAT3Base * ( (hrVat3/100))),2)
      updateSumObject.documentDescription9 = updateSumObject.documentDescription9 ? this.round(updateSumObject.documentDescription9, 2) : 0
      updateSumObject.supplierNetoAmount = updateSumObject.supplierNetoAmount ? this.round(updateSumObject.supplierNetoAmount, 2) : 0
      updateSumObject.supplierMargin = this.round(updateSumObject.documentTotalAmountNetto - updateSumObject.supplierNetoAmount, 2)
      updateSumObject.documentTotalAmountVAT = updateSumObject.documentTotalVAT1Amount + updateSumObject.documentTotalVAT2Amount + updateSumObject.documentTotalVAT3Amount
      updateSumObject.documentTotalAmountBrutto = updateSumObject.documentTotalAmountNetto + updateSumObject.documentTotalAmountVAT
      updateSumObject.documentTotalVAT1Per = hrVat1 ? this.round(hrVat1, 2) : 0
      updateSumObject.documentTotalVAT2Per = hrVat2 ? this.round(hrVat2, 2) : 0
      updateSumObject.documentTotalVAT3Per = hrVat3 ? this.round(hrVat3, 2) : 0

      // updateSumObject.documentTotalVAT1Base = hrVat1 && updateSumObject.documentTotalVAT1Amount ? this.round(updateSumObject.documentTotalVAT1Amount / (hrVat1/100), 2) : 0
      // updateSumObject.documentTotalVAT2Base = hrVat2 && updateSumObject.documentTotalVAT2Amount ? this.round(updateSumObject.documentTotalVAT2Amount / (hrVat2/100), 2) : 0
      // updateSumObject.documentTotalVAT3Base = hrVat3 && updateSumObject.documentTotalVAT3Amount ? this.round(updateSumObject.documentTotalVAT3Amount / (hrVat3/100), 2) : 0
      updateSumObject.FreeF1 = updateSumObject.FreeF1 ? this.round(updateSumObject.FreeF1, 2) : 0
      updateSumObject.FreeF2 = updateSumObject.FreeF2 ? this.round(updateSumObject.FreeF2, 2) : 0
      updateSumObject.FreeF3 = updateSumObject.FreeF3 ? this.round(updateSumObject.FreeF3, 2) : 0
      updateSumObject.FreeF4 = updateSumObject.FreeF4 ? this.round(updateSumObject.FreeF4, 2) : 0
      updateSumObject.FreeF5 = updateSumObject.FreeF5 ? this.round(updateSumObject.FreeF5, 2) : 0
      updateSumObject.documentDescription10 = updateSumObject.documentDescription9 - updateSumObject.documentTotalAmountNetto
      updateSumObject.documentTotalAmountPayInAdvance = updateSumObject.documentTotalAmountPayInAdvance ? this.round(updateSumObject.documentTotalAmountPayInAdvance, 2) : 0
      updateSumObject.documentTotalAmountToPay = updateSumObject.documentTotalAmountBrutto ? (this.round(updateSumObject.documentTotalAmountBrutto, 2) - (updateSumObject.documentTotalAmountPayInAdvance )): 0

      updateSumObject.documentTotalAmountNettoForeign = updateSumObject.documentTotalAmountNetto ? this.round((updateSumObject.documentTotalAmountNetto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountVATForeign = updateSumObject.documentTotalAmountVAT ? this.round((updateSumObject.documentTotalAmountVAT / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountBruttoForeign = updateSumObject.documentTotalAmountBrutto ? this.round((updateSumObject.documentTotalAmountBrutto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountPayInAdvanceForeign = this.round((updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate), 2)
      updateSumObject.documentTotalAmountToPayForeign = updateSumObject.documentTotalAmountBrutto ? (this.round((updateSumObject.documentTotalAmountBrutto/ this.ExRate), 2) - (updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate) ) : 0
      updateSumObject.documentTotalAmountDirectD1Fore = updateSumObject.documentTotalAmountDirectD1 ? this.round((updateSumObject.documentTotalAmountDirectD1 / this.ExRate), 2) : 0

      const newHead = {...this.$store.state.documentActivHead, ...updateSumObject}
      console.log('imam novi zbroj za glavu newHead ', newHead )
      if (newHead) {
        this.$store.dispatch('setDocumentActivHead', newHead)
      } else {
        this.$store.dispatch('setDocumentActivHead', {})
      }
    },
    setKategorije() {
      let uv = null
      if (this.newDD.itemVAT1Percentage === 25) {uv = 1}
      if (this.newDD.itemVAT1Percentage === 13) {uv = 2}
      if (this.newDD.itemVAT1Percentage === 5) {uv = 3}
      if (this.newDD.itemVAT1Percentage === 0) {uv = 4}
      // ako je dokument oznacen kao ino 
      if (this.$store.state.documentActivHead.exportDoc) {uv = 5 }
      // ako je dokument oznacen kao ppo
      if (this.$store.state.documentActivHead.PPO) {uv = 7 }
      if (this.$store.state.companyActiv.notinVAT === true) {uv = 13}
      const result = this.$store.state.OznakaKategorijePDV.filter(element => element.id === uv)
      if (result[0]) {
        const res = result[0]
        this.newDD.kod = res.value
        this.newDD.kodKategorije  = res.kodKategorije
        this.newDD.kodSheme = res.kodSheme
      }
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
    async printAna() {
      const newObj = {}
      this.ana = {...newObj}
      this.ana = {...this.documentAna}
      this.ana.items = this.items ? this.items : []
      this.ana.head1 = this.lang.itemCard + ': ' + this.itemCrd.itemName
      this.ana.head2 = 'Šifra artikla:' + this.itemCrd.itemID
      this.ana.head3 = 'Od:' +  this.localDate(this.$store.state.documentAna.docFromDate) + ' ,do ' + this.localDate(this.$store.state.documentAna.docToDate)
      this.ana.head4 = 'Skladište:' +  this.$store.state.warehousemarkid
      this.ana.head5 = ''
      this.ana.type = 1
      this.ana.Total1 = this.lang.itemTotalPlus + this.totalPcsPlus + ', ' +this.lang.itemTotalMinus + ':' + this.totalPcsMinus + ', ' +  this.lang.itemTotal + ': ' + this.totalPcs
      this.ana.Total2 = this.totalSupp ? this.lang.ItemSuppPriceAmount + ': ' + this.localMoney(this.totalSupp) : ''
      this.ana.Total3 = this.totalMargin ? this.lang.ItemMarginAmount + ': ' + this.localMoney(this.totalMargin) : ''
      this.ana.Total4 = this.totalNetto ? this.lang.ItemBaseAmountNoVAT + ': ' + this.localMoney(this.totalNetto) : ''
      this.ana.Total5 = this.totalVAT ? this.lang.ItemVAT1Amount + ': ' + this.localMoney(this.totalVAT)  : ''
      this.ana.Total6 = this.totalTotal ? this.lang.ItemFullTotal + ': ' + this.localMoney(this.totalTotal) : ''

      await this.$store.dispatch('setPrintObj', this.ana)
      await this.$refs.prnt.print()
    },
  },
  computed: {

  },
  watch: {

  },
  components: {
    DocumentPrintItemCard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


